import React from 'react';
import classes from './homeHeader.module.scss';
import useUserHook from 'hooks/useUserHook';

export const HomeHeader = () => {
    const { firstName } = useUserHook();
    return <div className={classes.headline}>{`Hello ${firstName}`}</div>;
};
